// React.
import React from 'react';

// Material UI.
import Button from '@material-ui/core/Button';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Table } from '@material-ui/core';

// Components.
import PointsIcon from '../utils/PointsIcon';

// Translations.
import { useTranslation } from 'react-i18next';

// Styles.
import useStyles from './PointsComponentsStyles';

// Global config.
import { getProjectConfig } from '../../getProjectConfig';

interface PointsHistoryModalProps {
  open: boolean;
  onClose: () => void;
  pointsHistory: Array<any>;
  totalPoints: number;
}

const PointsHistoryModal = ({ open, onClose, pointsHistory, totalPoints }: PointsHistoryModalProps) => {
  const classes = useStyles();
  const [t] = useTranslation('global');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby='Points History'
      className={`${classes.modalOverlay} ${isMobile ? classes.modalOverlayMobile : ''}`}
    >
      <Paper elevation={3} className={classes.modalPaper}>
        <div className={classes.points}>
          <Typography variant='h4' className={classes.pointsTitle}>
            {getProjectConfig().STORE_CREDITS_NAME}
          </Typography>
          <Typography>
            {t('users.user-points-text', {
              name: getProjectConfig().STORE_CREDITS_NAME,
            })}
          </Typography>
          <Typography
            variant='h3'
            color='primary'
            className={classes.pointsNumber}
          >
            <PointsIcon width={'30'} />
            {totalPoints?.toLocaleString('en-US')}
          </Typography>
        </div>
        <div className={classes.pointsModalTableContainer}>
          <Table size="medium" aria-label="points history table" className={`${classes.tableWrapper} ${classes.pointsModalTable}`}>
            <TableHead>
              <TableRow>
                <TableCell>{t('users.points')}</TableCell>
                <TableCell>{t('users.created-at')}</TableCell>
                <TableCell>{t('users.expiration-date')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pointsHistory && pointsHistory.length > 0 ? (
                pointsHistory.map((entry: any, index: number) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">{entry.pointsRemaining?.toLocaleString('en-US')}</TableCell>
                    <TableCell>{entry.createdAt}</TableCell>
                    <TableCell>{entry.expirationDate}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    {t('users.no-points-history')}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <div className={classes.pointsModalButtonWrapper}>
          <Button
            variant='contained'
            color='primary'
            onClick={onClose}
          >
            {t('users.close')}
          </Button>
        </div>
      </Paper>
    </Modal>
  );
};

export default PointsHistoryModal;
